import React, { PureComponent } from 'react';
import { translate, translateToHTML } from '../../../base/i18n/functions';
import { connect } from '../../../base/redux/functions';
import Dialog from '../../../base/ui/components/web/Dialog';
// import { safeDecodeURIComponent } from "../../../base/util";
import { cancelWaitForOwner } from '../../actions.web';
// @ts-ignore
import { jitsiLocalStorage } from "@jitsi/js-utils";
import { getJwt } from "../../../welcome/actions";
import { UserManager } from "oidc-client";
// @ts-ignore
import { safeDecodeURIComponent } from '../../../base/util';
/**
 * Authentication message dialog for host confirmation.
 *
 * @returns {React$Element<any>}
 */
class WaitForOwnerDialog extends PureComponent {
    /**
     * Instantiates a new component.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._onCancelWaitForOwner = this._onCancelWaitForOwner.bind(this);
        this._onIAmHost = this._onIAmHost.bind(this);
    }
    /**
     * Called when the cancel button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onCancelWaitForOwner() {
        const { dispatch } = this.props;
        dispatch(cancelWaitForOwner());
    }
    /**
     * Called when the OK button is clicked.
     *
     * @private
     * @returns {void}
     */
    _onIAmHost() {
        const { onAuthNow, _room, ssoConf } = this.props;
        if (_room && !this.isUserLoggedIn()) {
            // onAuthNow && onAuthNow();
            const ssoConfig = {
                authority: ssoConf.authority,
                client_id: ssoConf.client_id,
                redirect_uri: ssoConf.redirect_uri,
                response_type: ssoConf.response_type,
                scope: ssoConf.scope,
                post_logout_redirect_uri: ssoConf.post_logout_redirect_uri,
            };
            this.userManager = new UserManager(ssoConfig);
            jitsiLocalStorage.setItem("bbbssoroomname", _room);
            this.userManager.signinRedirect().then(function () {
                console.log('signinRedirect ok');
            }).catch(function (err) {
                console.log('signinRedirect error:', err);
            });
        }
        else {
            let requestBody = {};
            requestBody = {
                user_token: jitsiLocalStorage.getItem("user_token"),
                room_name: _room,
                ssoConfRedirect_uri: ssoConf.redirect_uri
            };
            getJwt(requestBody);
        }
    }
    isUserLoggedIn() {
        let user_token = jitsiLocalStorage.getItem("user_token");
        if (user_token) {
            return true;
        }
        return false;
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     */
    render() {
        const { _room: room, t } = this.props;
        return (React.createElement(Dialog, { disableBackdropClose: true, hideCloseButton: true, ok: { translationKey: 'dialog.IamHost' }, onCancel: this._onCancelWaitForOwner, onSubmit: this._onIAmHost, titleKey: t('dialog.WaitingForHostTitle') },
            React.createElement("span", null, translateToHTML(t, "dialog.WaitForHostMsg", { room }))));
    }
}
// Following code block is commented to make sure room names comes from the
//  dialog property setup
//  if that does not come we need to pass it using the below function correctly
/**
 * Maps (parts of) the Redux state to the associated props for the
 * {@code WaitForOwnerDialog} component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {Props}
 */
function mapStateToProps(state) {
    const { authRequired } = state["features/base/conference"];
    const { ssoConf } = state["features/base/config"];
    return {
        _room: authRequired && safeDecodeURIComponent(authRequired.getName()),
        ssoConf: ssoConf
    };
}
export default translate(connect(mapStateToProps)(WaitForOwnerDialog));
// export default translate(connect()(WaitForOwnerDialog));
